import { styled } from '@mui/material/styles';

export const StyledBulkContentContainerDiv = styled('div')`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  overflow: auto;
`;
